/**
 * SWW (SpellingWW) Module Seeds - Consolidated Index
 *
 * Modular seed structure matching GET/TGL pattern.
 * Each family is stored in its own JSON file.
 *
 * Phase H-4: Migrated from flat seed_SWW.json to folder-based pattern.
 */

import SWW_TT_STAM from './SWW-TT-STAM.json'
import SWW_TT_INV_JIJ from './SWW-TT-INV-JIJ.json'
import SWW_TT_INV_TRICK from './SWW-TT-INV-TRICK.json'
import SWW_TT_DSTAM from './SWW-TT-DSTAM.json'
import SWW_TT_MEERVOUD from './SWW-TT-MEERVOUD.json'
import SWW_TT_ZIJN_HEBBEN from './SWW-TT-ZIJN-HEBBEN.json'
import SWW_VT_ZWAK_KOF from './SWW-VT-ZWAK-KOF.json'
import SWW_VD_KOF from './SWW-VD-KOF.json'
import SWW_VT_STERK from './SWW-VT-STERK.json'
import SWW_VT_DUBBEL from './SWW-VT-DUBBEL.json'
import SWW_VD_HOMOFOON from './SWW-VD-HOMOFOON.json'
import SWW_VT_VZFS from './SWW-VT-VZFS.json'
import SWW_BN_VD_KORT from './SWW-BN-VD-KORT.json'
import SWW_BN_VD_DUBBEL from './SWW-BN-VD-DUBBEL.json'
import SWW_LEEN_ENG_STAM from './SWW-LEEN-ENG-STAM.json'
import SWW_LEEN_ENG_KOF from './SWW-LEEN-ENG-KOF.json'

const SWW_FAMILY_SEEDS = [
  { file: 'src/data/seeds/SWW/SWW-TT-STAM.json', data: SWW_TT_STAM },
  { file: 'src/data/seeds/SWW/SWW-VT-ZWAK-KOF.json', data: SWW_VT_ZWAK_KOF },
  { file: 'src/data/seeds/SWW/SWW-VD-KOF.json', data: SWW_VD_KOF },
  { file: 'src/data/seeds/SWW/SWW-TT-INV-JIJ.json', data: SWW_TT_INV_JIJ },
  { file: 'src/data/seeds/SWW/SWW-VT-STERK.json', data: SWW_VT_STERK },
  { file: 'src/data/seeds/SWW/SWW-TT-DSTAM.json', data: SWW_TT_DSTAM },
  { file: 'src/data/seeds/SWW/SWW-TT-INV-TRICK.json', data: SWW_TT_INV_TRICK },
  { file: 'src/data/seeds/SWW/SWW-TT-MEERVOUD.json', data: SWW_TT_MEERVOUD },
  {
    file: 'src/data/seeds/SWW/SWW-TT-ZIJN-HEBBEN.json',
    data: SWW_TT_ZIJN_HEBBEN,
  },
  { file: 'src/data/seeds/SWW/SWW-VT-DUBBEL.json', data: SWW_VT_DUBBEL },
  { file: 'src/data/seeds/SWW/SWW-VD-HOMOFOON.json', data: SWW_VD_HOMOFOON },
  { file: 'src/data/seeds/SWW/SWW-VT-VZFS.json', data: SWW_VT_VZFS },
  { file: 'src/data/seeds/SWW/SWW-BN-VD-KORT.json', data: SWW_BN_VD_KORT },
  { file: 'src/data/seeds/SWW/SWW-BN-VD-DUBBEL.json', data: SWW_BN_VD_DUBBEL },
  {
    file: 'src/data/seeds/SWW/SWW-LEEN-ENG-STAM.json',
    data: SWW_LEEN_ENG_STAM,
  },
  { file: 'src/data/seeds/SWW/SWW-LEEN-ENG-KOF.json', data: SWW_LEEN_ENG_KOF },
] as const

const allQuestions = SWW_FAMILY_SEEDS.flatMap(({ file, data }) =>
  data.questions.map((question: any) => ({ ...question, __sourceFile: file })),
)

export default {
  module: 'SpellingWW' as const,
  moduleCode: 'SWW',
  version: '5.3-modular',
  taxonomyVersion: '4.1',
  questions: allQuestions,
}
